import { Route } from '@angular/router';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { RolesGuard } from './core/auth/guards/roles.guard';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/orders'
    {path: '', pathMatch : 'full', redirectTo: 'welcome'},

    // Redirect signed in user to the '/orders'
    //
    // After the user signs in, the sign in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'welcome'},

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.module').then(m => m.AuthSignInModule)}
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.module').then(m => m.AuthSignOutModule)}
        ]
    },

    // Admin routes
    {
        path       : '',
        canActivate: [AuthGuard, RolesGuard],
        canActivateChild: [AuthGuard, RolesGuard],
        component  : LayoutComponent,
        children   : [
            {path: 'welcome', loadChildren: () => import('app/modules/admin/welcome/welcome.module').then(m => m.WelcomeModule), data: {roles: ['admin']}},
            {path: 'dashboard', loadChildren: () => import('app/modules/admin/dashboard/dashboard.module').then(m => m.DashboardModule), data: {roles: ['admin']}},
            {path: 'participants', loadChildren: () => import('app/modules/admin/participants/participant.module').then(m => m.ParticipantModule), data: {roles: ['admin']}},
            {path: 'sessions', loadChildren: () => import('app/modules/admin/sessions/session.module').then(m => m.SessionsModule), data: {roles: ['admin']}},
            {path: 'exports', loadChildren: () => import('app/modules/admin/exports/exports.module').then(m => m.ExportsModule), data: {roles: ['admin']}},
            {path: 'answer-sheets', loadChildren: () => import('app/modules/admin/answer-sheets/answer-sheets.module').then(m => m.AnswerSheetsModule), data: {roles: ['admin']}},
            {path: 'collab-protocols', loadChildren: () => import('app/modules/admin/collab-protocols/collab-protocols.module').then(m => m.CollabProtocolsModule), data: {roles: ['admin']}},
            {path: 'contestations', loadChildren: () => import('app/modules/admin/contestations/contestations.module').then(m => m.ContestationsModule), data: {roles: ['admin']}},
            {path: 'sessions-feedback', loadChildren: () => import('app/modules/admin/sessions-feedback/sessions-feedback.module').then(m => m.SessionsFeedbackModule), data: {roles: ['admin']}},
            {path: 'tests', loadChildren: () => import('app/modules/admin/contest-tests/contest-tests.module').then(m => m.ContestTestsModule), data: {roles: ['admin']}},
            {path: 'settings', loadChildren: () => import('app/modules/admin/settings/settings.module').then(m => m.SettingsModule), data: {roles: ['admin']}},
            {path: 'task-monitor', loadChildren: () => import('app/modules/admin/task-monitor/task-monitor.module').then(m => m.TaskMonitorModule), data: {roles: ['admin']}},
            {path: 'cookie-consent', loadChildren: () => import('app/modules/admin/cookie-consent/cookie-consent.module').then(m => m.CookieConsentModule), data: {roles: ['admin']}},
            {path: 'emails', loadChildren: () => import('app/modules/admin/email-templates/email-templates.module').then(m => m.EmailTemplatesModule), data: {roles: ['admin']}},
            {path: 'media', loadChildren: () => import('app/modules/admin/media/media.module').then(m => m.MediaModule), data: {roles: ['admin']}},
            {path: 'site-content', loadChildren: () => import('app/modules/admin/site-content/site-content.module').then(m => m.SiteContentModule), data: {roles: ['admin']}},
            {path: 'jobs', loadChildren: () => import('app/modules/admin/jobs/jobs.module').then(m => m.JobsModule), data: {roles: ['admin']}},
            // Etapa history (parametric — driven by Settings.PastEditions)
            {path: 'history/:contestIdentifier/sessions', loadChildren: () => import('app/modules/admin/etapa-history/sessions/session.module').then(m => m.EtapaSessionsModule), data: {roles: ['admin']}},
            {path: 'history/:contestIdentifier/feedback', loadChildren: () => import('app/modules/admin/sessions-feedback/sessions-feedback.module').then(m => m.SessionsFeedbackModule), data: {roles: ['admin']}},
            {path: 'history/:contestIdentifier/tests',    loadChildren: () => import('app/modules/admin/contest-tests/contest-tests.module').then(m => m.ContestTestsModule), data: {roles: ['admin'], archive: true}},
        ]
    },

    {path: '**', pathMatch : 'full', redirectTo: 'sign-in'},

];
